class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.searchLabel = this.querySelector('.field__label--search');
    // Asegurar que tenemos el botón de reset correcto
    this.resetButton = this.querySelector('.reset__button') || this.querySelector('button[type="reset"]');
    this.setupEventListeners();
    // Usar setTimeout para asegurar que el DOM esté completamente cargado
    setTimeout(() => {
      this.updateLabelVisibility();
      this.updateResetButtonVisibility();
    }, 0);
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    this.input.addEventListener('blur', this.onInputBlur.bind(this));
    this.input.addEventListener('input', this.onInputChange.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
      this.updateLabelVisibility();
      // Forzar actualización después del reset
      setTimeout(() => {
        this.updateResetButtonVisibility();
      }, 0);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputChange() {
    this.updateLabelVisibility();
    this.updateResetButtonVisibility();
  }

  onChange() {
    super.onChange();
    this.updateResetButtonVisibility();
  }

  updateLabelVisibility() {
    if (!this.searchLabel) return;
    const hasValue = this.input.value.length > 0;
    if (hasValue) {
      this.searchLabel.classList.add('field__label--hidden');
    } else {
      this.searchLabel.classList.remove('field__label--hidden');
    }
  }

  updateResetButtonVisibility() {
    if (!this.resetButton || !this.input) return;
    const hasValue = this.input.value && this.input.value.trim().length > 0;
    
    if (hasValue) {
      this.resetButton.classList.remove('tw-hidden');
    } else {
      this.resetButton.classList.add('tw-hidden');
    }
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
      // Ocultar label cuando se hace focus en mobile
      if (this.searchLabel) {
        this.searchLabel.classList.add('field__label--hidden');
      }
    }
  }

  onInputBlur() {
    // Mostrar label nuevamente si no hay texto al perder el focus (solo en mobile)
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen && this.input.value.length === 0) {
      if (this.searchLabel) {
        this.searchLabel.classList.remove('field__label--hidden');
      }
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
